'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noopAction = exports.getMeta = exports.hasError = exports.getPayload = exports.msgObj = exports.arg2True = exports.payloadFromErr = exports.payloadIsErr = undefined;

var _stubTrue2 = require('lodash/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _overSome2 = require('lodash/overSome');

var _overSome3 = _interopRequireDefault(_overSome2);

var _overEvery2 = require('lodash/overEvery');

var _overEvery3 = _interopRequireDefault(_overEvery2);

var _over2 = require('lodash/over');

var _over3 = _interopRequireDefault(_over2);

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isError2 = require('lodash/isError');

var _isError3 = _interopRequireDefault(_isError2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _identical2 = require('lodash/fp/identical');

var _identical3 = _interopRequireDefault(_identical2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _cond2 = require('lodash/cond');

var _cond3 = _interopRequireDefault(_cond2);

var _constant2 = require('lodash/constant');

var _constant3 = _interopRequireDefault(_constant2);

exports.createGetPayload = createGetPayload;
exports.validateProps = validateProps;
exports.createAction = createAction;
exports.createSimpleAction = createSimpleAction;

var _omitBy = require('lodash/fp/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _pick = require('lodash/fp/pick');

var _pick2 = _interopRequireDefault(_pick);

var _zipObject = require('lodash/fp/zipObject');

var _zipObject2 = _interopRequireDefault(_zipObject);

var _capeLodash = require('cape-lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var payloadIsErr = exports.payloadIsErr = (0, _overSome3.default)(_isError3.default, (0, _property3.default)('error'), (0, _property3.default)('isBoom'));
var payloadFromErr = exports.payloadFromErr = (0, _pick2.default)(['error', 'message', 'fileName', 'lineNumber', 'type']);
var arg2True = exports.arg2True = (0, _flow3.default)((0, _nthArg3.default)(1), (0, _identical3.default)(true));
var msgObj = exports.msgObj = (0, _capeLodash.createObj)('message');
function createGetPayload() {
  var lastFunc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _identity3.default;

  return (0, _cond3.default)([[(0, _overEvery3.default)(arg2True, _isString3.default), msgObj], [payloadIsErr, payloadFromErr], [_stubTrue3.default, lastFunc]]);
}
var getPayload = exports.getPayload = createGetPayload();
var hasError = exports.hasError = (0, _cond3.default)([[(0, _overSome3.default)(arg2True, payloadIsErr), _stubTrue3.default], [_stubTrue3.default, _noop3.default]]);
var getMeta = exports.getMeta = (0, _cond3.default)([[arg2True, (0, _nthArg3.default)(2)], [_stubTrue3.default, (0, _nthArg3.default)(1)]]);
function validateProps(type, payloadCreator, metaCreator) {
  if (!(0, _isString3.default)(type)) throw new Error('type must be a string');
  if (!(0, _isFunction3.default)(payloadCreator)) throw new Error('payloadCreator must be a func.');
  if (!(0, _isFunction3.default)(metaCreator)) throw new Error('metaCreator must be a func.');
}
// @TODO Need some validation of payload.
function createAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getPayload;
  var metaCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getMeta;

  validateProps(type, payloadCreator, metaCreator);
  return (0, _flow3.default)((0, _over3.default)((0, _constant3.default)(type), payloadCreator, hasError, metaCreator), (0, _zipObject2.default)(['type', 'payload', 'error', 'meta']), (0, _omitBy2.default)(_isUndefined3.default));
}
function createSimpleAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity3.default;
  var metaCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop3.default;

  validateProps(type, payloadCreator, metaCreator);
  return (0, _flow3.default)((0, _over3.default)((0, _constant3.default)(type), payloadCreator, metaCreator), (0, _zipObject2.default)(['type', 'payload', 'meta']), (0, _omitBy2.default)(_isUndefined3.default));
}
var noopAction = exports.noopAction = (0, _flow3.default)((0, _capeLodash.createObj)('type'), _constant3.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux/lib/createAction.js
// module id = 373
// module chunks = 0